import { render } from "./main.vue?vue&type=template&id=6ef0938c&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=6ef0938c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef0938c"]])

export default __exports__